import { AUTOMATION_MAX_TOPIC_LENGTH } from "@/constants/dashboard/automation";
import type { PurposeType } from "@/types/automation";

const newsList = [
  // ko
  'n.news.naver.com',
  'chosun.com',
  'mk.co.kr',
  'yna.co.kr',
  'newsis.com',
  'donga.com',
  'hankyung.com',
  'khan.co.kr',
  'news.mt.co.kr',
  'joongang.co.kr',
  'edaily.co.kr',
  'news.kbs.co.kr',
  'news1.kr',
  'news.sbs.co.kr',
  'imnews.imbc.com',
  'hani.co.kr',
  'fnnews.com',
  'asiae.co.kr',
  'go.seoul.co.kr',
  'xportsnews.com',
  'cjnews.cj.net',
  'moneys.co.kr',
  // en
  'news.bbc.co.uk',
  'economist.com',
  'nytimes.com',
  'msnbc.msn.com',
  'cnn.com',
  'abcnews.go.com',
  'online.wsj.com',
  'time.com',
  'usatoday.com',
  'washingtonpost.com',
  'forbes.com',
  'guardian.co.uk',
  'latimes.com',
  'timesonline.co.uk',
  'foxnews.com',
  'telegraph.co.uk',
  'huffingtonpost.com',
  'npr.org',
  'cbsnews.com',
  'csmonitor.com',
  'chicagotribune.com',
  'newsweek.com',
  'apnews.com',
  'reuters.com',
  'newsasfacts.com',
  'edition.cnn.com',
  'bbc.com',
  'news.',
  'usatoday.com',
  'cbsnews.com',
  'abcnews.go.com',
  'npr.org',
  'politico.com',
  'wsj.com',
  'huffpost.com',
  'economist.com',
  'forbes.com',
  'time.com',
  'newsweek.com',
  'latimes.com',
  'chicagotribune.com',
  'bostonglobe.com',
  'theatlantic.com',
  'nationalgeographic.com',
  'usatoday.com/sports',
  'espn.com',
  'si.com',
  'huffpost.com',
  'buzzfeednews.com',
  'independent.co.uk',
  'salon.com',
  'slate.com',
  'vox.com',
  'thedailybeast.com',
  'thehill.com',
  'cnbc.com/business',
  'businessinsider.com',
  'ft.com',
  'telegraph.co.uk',
  'thesun.co.uk',
  'dailymail.co.uk',
  'mirror.co.uk',
  'thetimes.co.uk',
  'skynews.com',
  'reuters.com/business',
  'bloomberg.com/businessweek',
  'marketwatch.com',
  'fortune.com',
  'money.com',
  'thestreet.com',
  'barrons.com',
  'nypost.com',
  'newyorker.com',
  'vanityfair.com',
  'wired.com',
  'techcrunch.com',
  'mashable.com',
  'gizmodo.com',
  'arstechnica.com',
  'cnet.com',
  'engadget.com',
  'theverge.com',
  'pcmag.com',
  'variety.com',
  'deadline.com',
  'rollingstone.com',
  'pitchfork.com',
  'billboard.com',
  'ew.com',
  'eonline.com',
  'people.com',
  'tmz.com',
  'vogue.com',
  'elle.com',
  'harpersbazaar.com',
  'cosmopolitan.com',
  'marieclaire.com',
  'instyle.com',
  'glamour.com',
  'refinery29.com',
  'bustle.com',
  'jezebel.com',
  'teenvogue.com',
  'theguardian.com/sport',
  'bleacherreport.com',
  'sportsnet.ca',
  'espncricinfo.com',
  'nhl.com',
  'nba.com',
  'mlssoccer.com',
  'bbc.com/sport',
  'aljazeera.com/sport',
  'theathletic.com',
  'tennis.com',
  'golfdigest.com',
  'sbnation.com',
  '/news',
];

export const checkNewsSite = (url: string) => {
  for (const item of newsList) {
    try {
      let domain = new URL(url).hostname;
      if (domain.replace('www.', '') === item) return item;
    } catch (e) { }
  }
  return false;
};

const invalidList = [
  'tiktok.com',
  'docs.google.com',
  'facebook.com',
  'play.google.com',
  'open.spotify.com',
  'instagram.com',
  'canva.com',
  'twitter.com',
  'x.com',
];

const checkInvalidUrl = (url: string) => {
  for (const item of invalidList) {
    try {
      let domain = new URL(url).hostname;
      if (domain.replace('www.', '') === item) return true;
    } catch (e) { }
  }
  return false;
};

export const checkYoutubeUrl = (url: string) => {
  // 비디오 ID를 추출하기 위한 정규 표현식
  const videoIdRegex =
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

  // 채널 ID를 추출하기 위한 정규 표현식
  const channelIdRegex =
    /(?:https?:\/\/)?(?:www\.)?youtube\.com\/(?:c\/|channel\/|user\/)?([a-zA-Z0-9_-]+)/;

  // Shorts 링크 처리
  const shortsRegex =
    /(?:https?:\/\/)?(?:www\.)?youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})/;

  return videoIdRegex.test(url) || shortsRegex.test(url) || channelIdRegex.test(url);
}

export const preCheckTopic = (input: string): { purpose: PurposeType; planId: string } => {
  if (input.length <= AUTOMATION_MAX_TOPIC_LENGTH) {
    return {
      purpose: "youtube",
      planId: "topic_2",
    }
  }
  return {
    purpose: "news",
    planId: "article_1",
  }
}

export const preCheckUrl = (input: string): { purpose: PurposeType; planId: string; site: string } | null => {
  try {
    const url = new URL(input);

    if (checkInvalidUrl(url.href)) {
      throw new Error();
    }

    const isNews = checkNewsSite(url.href);

    if (isNews) {
      return {
        purpose: "news",
        planId: "article_1",
        site: isNews,
      }
    }

    if (url.hostname.includes("amazon.")) {
      return {
        purpose: "commerce",
        planId: "template_4",
        site: "amazon.com",
      }
    }

    if (url.hostname.includes("coupang.")) {
      return {
        purpose: "commerce",
        planId: "template_4",
        site: "coupang.com",
      }
    }

    if (
      [
        "smartstore.naver.com",
        "shopping.naver.com",
        "brand.naver.com",
      ].some((origin) => url.hostname.includes(origin))
    ) {
      return {
        purpose: "commerce",
        planId: "template_4",
        site: "naver.com",
      }
    }

    // shopify
    if (url.hostname.includes("shopify.")) {
      return {
        purpose: "commerce",
        planId: "template_4",
        site: "shopify.com",
      }
    }
    if (url.hostname.includes("www.harvestarray.com")) {
      return {
        purpose: "commerce",
        planId: "template_4",
        site: "www.harvestarray.com",
      }
    }

    if (checkYoutubeUrl(url.href)) {
      return {
        purpose: "youtube",
        planId: "topic_2",
        site: "",
      }
    }

    return {
      purpose: "business",
      planId: "presentation_1",
      site: "",
    }
  } catch (e) {
    return null;
  }
}

export const preCheck = (userInputs: string[]) => {
  const result = { purpose: "", planId: "", site: "" };

  if (userInputs.length === 1) {
    const userInput = userInputs[0];

    if (userInput.startsWith("http")) {
      const preCheckUrlResult = preCheckUrl(userInput);

      if (preCheckUrlResult) {
        result.purpose = preCheckUrlResult.purpose;
        result.planId = preCheckUrlResult.planId;
        result.site = preCheckUrlResult.site;
      }
    } else {
      const topicPreCheckResult = preCheckTopic(userInput);

      result.purpose = topicPreCheckResult.purpose;
      result.planId = topicPreCheckResult.planId;
    }
  }

  return result;
}

export function checkUrlAvailable(url: string) {
  try {
    const domain = new URL(url);
    const hostname = domain.hostname;

    if (invalidList.some((v) => hostname.includes(v))) {
      throw new Error();
    }
    
    return true;
  } catch (e) {
    return false;
  }
}